import {
  RESET_PROFILES,
  RESET_PROFILE,
  RESET_ERROR,
  GET_PROFILES_BACKOFFICE,
  GET_PROFILES_CLIENT,
  SET_PROFILES,
  API_ERROR,
  CREATE_PROFILE,
  CREATE_PROFILE_SUCCESS,
  GET_PROFILE,
  SET_PROFILE,
  EDIT_PROFILE,
  EDIT_PROFILE_SUCCESS,
  DELETE_PROFILE,
  DELETE_PROFILE_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorProfile: false,
  loadingProfile: false,
  dataProfile: null,
  successProfile: false,
};

const Profile = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PROFILES:
      state = {
        ...state,
        errorProfile: false,
        loadingProfile: false,
        loadingProfileDelete: false,
        successProfile: false,
        dataProfile: null,
        dataProfileDelete: null,
      };
      break;
    case RESET_PROFILE:
      state = {
        ...state,
        errorProfile: false,
        loadingProfile: false,
        successProfile: false,
        dataProfileGetSet: null,
        dataProfileEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorProfile: false,
        loadingProfile: false,
        loadingProfileEditCreate: false,
        loadingProfileActivate: false,
        successProfile: false,
      };
      break;
    case GET_PROFILES_BACKOFFICE:
      state = {
        ...state,
        errorProfile: false,
        loadingProfile: true,
        dataProfile: null,
      };
      break;
    case GET_PROFILES_CLIENT:
      state = {
        ...state,
        errorProfile: false,
        loadingProfile: true,
        dataProfile: null,
      };
      break;
    case SET_PROFILES:
      state = {
        ...state,
        errorProfile: false,
        loadingProfile: false,
        dataProfile: action.payload,
      };
      break;
    case CREATE_PROFILE:
      state = {
        ...state,
        errorProfile: false,
        loadingProfileEditCreate: true,
        dataProfileEditCreate: action.payload,
        successProfile: false,
      };
      break;
    case CREATE_PROFILE_SUCCESS:
      state = {
        ...state,
        errorProfile: false,
        loadingProfileEditCreate: false,
        dataProfileEditCreate: action.payload,
        successProfile: true,
      };
      break;
    case GET_PROFILE:
      state = {
        ...state,
        errorProfile: false,
        loadingProfile: true,
        dataProfileGetSet: null,
      };
      break;
    case SET_PROFILE:
      state = {
        ...state,
        errorProfile: false,
        loadingProfile: false,
        dataProfileGetSet: action.payload,
      };
      break;
    case EDIT_PROFILE:
      state = {
        ...state,
        errorProfile: false,
        loadingProfileEditCreate: true,
        dataProfileEditCreate: action.payload,
        successProfile: false,
      };
      break;
    case EDIT_PROFILE_SUCCESS:
      state = {
        ...state,
        errorProfile: false,
        loadingProfileEditCreate: false,
        dataProfileEditCreate: action.payload,
        successProfile: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorProfile: action.payload,
        loadingProfile: false,
        loadingProfileDelete: false,
        successProfile: false,
      };
      break;
    case DELETE_PROFILE:
      state = {
        ...state,
        errorProfile: false,
        loadingProfileDelete: true,
        dataProfileDelete: action.payload,
        successProfile: false,
      };
      break;
    case DELETE_PROFILE_SUCCESS:
      state = {
        ...state,
        errorProfile: false,
        loadingProfileDelete: false,
        dataProfileDelete: action.payload,
        successProfile: true,
      };
      break;
    default:
      // state = { ...state, errorProfile: false, loadingProfile: false };
      break;
  }
  return state;
};

export default Profile;
